import React, { useEffect, useState } from "react";
import {
  TextField,
  MenuItem,
  Select,
  Button,
  Box,
  Grid,
  Stepper,
  Step,
  StepLabel,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import { isCompany } from "../../Config/isCompany";
import NotFoundPage from "../../Pages/NotFoundPage";

const CompanyDetailsForm = () => {
  const [formValues, setFormValues] = useState({
    about_company: "",
    company_address: "",
    city: "",
    profile_link: "",
    profile_image: null,
  });

  const [activeStep, setActiveStep] = useState(0);
  const [isRegister, setIsRegister] = useState(false);
  const [loading, setLoading] = useState(false);

  const steps = ["Hakkımızda", "Adres", "Logo"];
  const cities = [
    "Genel", "Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ankara", "Antalya",
    "Ardahan", "Artvin", "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl",
    "Bitlis", "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır",
    "Düzce", "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Gaziantep", "Giresun",
    "Gümüşhane", "Hakkari", "Hatay", "Iğdır", "Isparta", "İstanbul", "İzmir", "Kahramanmaraş",
    "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kırıkkale", "Kırklareli", "Kırşehir",
    "Kilis", "Kocaeli", "Konya", "Kütahya", "Malatya", "Manisa", "Mardin", "Mersin", "Muğla",
    "Muş", "Nevşehir", "Niğde", "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Siirt",
    "Sinop", "Sivas", "Şanlıurfa", "Şırnak", "Tekirdağ", "Tokat", "Trabzon", "Tunceli",
    "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak"
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://kariyer.biyomed.net/api/companies/getOneDetails",
          {
            withCredentials: true,
          }
        );
        console.log(response.data);
        setIsRegister(response.data ? true : false);
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep((prevStep) => prevStep + 1);
    }
  };


  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };
  const handleRemoveDocument = (field) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [field]: null,  // Dosyayı null yapıyoruz
    }));
  };


  const handleDocumentChange = (e, type) => {
    const file = e.target.files[0];

    if (!file) {
      alert("Lütfen bir dosya seçin!");
      return;
    }

    // Dosya boyutu kontrolü (örneğin, 5 MB sınırı)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      alert("Dosya boyutu 5MB'ı geçemez!");
      e.target.value = ""; // Dosya seçimini sıfırla
      return;
    }

    // Dosya türü kontrolü
    let allowedTypes = [];
    if (type === "profile_image") {
      // CV dosyaları için sadece PDF
      allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    }

    if (!allowedTypes.includes(file.type)) {
      alert("Geçersiz dosya türü! Lütfen uygun formatta bir dosya seçin.");
      e.target.value = ""; // Dosya seçimini sıfırla
      return;
    }

    // Dosyayı doğrudan state'e set et
    switch (type) {
      case "profile_image":
        setFormValues((prev) => ({
          ...prev,
          profile_image: file,
        }));
        break;
      default:
        console.error("Bilinmeyen dosya tipi:", type);
    }
  };
  const isValidUrl = (url) => {
    const regex = /^(https?:\/\/)?([a-z0-9.-]+)(\.[a-z]{2,})((\/[^\s]*)*)$/i;
    return regex.test(url);
  };


  const handleSubmit = async (e) => {
    setLoading(true)
    if (!isValidUrl(formValues.profile_link)) {
      alert("Geçerli bir link giriniz")
      setLoading(false)
      return
    }
    e.preventDefault();
    const formData = new FormData();
    Object.entries(formValues).forEach(([key, value]) => {
      // Append fields directly to formData, skipping the Base64 conversion
      if (value instanceof File) {
        formData.append(key, value); // Append file objects as files
      } else {
        formData.append(key, value);
      }
    });

    try {
      const response = await axios.post(
        "https://kariyer.biyomed.net/api/company/createCompanyDetails",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );
      console.log("Response:", response.data);
      setLoading(false)
      window.location.href = "/companyprofile"
    } catch (err) {
      console.error("Error submitting form:", err);
      setLoading(false)
    }
  };


  return (
    <>{isCompany ? <div> {isRegister ?             
            <div
              style={{
                paddingTop: 250,
                paddingBottom: 200,
                paddingLeft: 100,
                display: "block",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
      <p style={{ fontSize: "30px", marginTop: 10  }}>Bilgileriniz Başarılı bir şekilde kayıt edildi</p>
      <Button style={{ backgroundColor: "#23c0e9", color: "black", marginTop: 50, marginLeft:900 }}><a href="/" style={{ color: "black" }}> Anasayfa'ya dön</a></Button>

    </div> : <Box component="form" sx={{ p: 4 }}>
      <Stepper activeStep={activeStep} sx={{ mb: 4, mt: 20 }}>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {activeStep === 0 && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <label>Firma Hakkında</label>
            <TextField
              fullWidth
              name="about_company"
              value={formValues.about_company}
              onChange={handleInputChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <label>Profil Linki </label>
            <TextField
              fullWidth
              name="profile_link"
              value={formValues.profile_link}
              onChange={handleInputChange}
            />
          </Grid>
        </Grid>
      )}

      {activeStep === 1 && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <label>İl </label>
            <Select
              name="city"
              value={formValues.city}
              onChange={handleInputChange}
              style={{ width: "100%" }}
            >
              <MenuItem value="" disabled>İl Seçiniz</MenuItem>
              {cities.map((city, index) => (
                <MenuItem key={index} value={city}>
                  {city}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={12} sm={6}>
            <label>Firma Adresi</label>
            <TextField
              fullWidth
              label="Firma Adresi"
              name="company_address"
              value={formValues.company_address}
              onChange={handleInputChange}
            />
          </Grid>


        </Grid>
      )}

      {activeStep === 2 && (

        <Grid item xs={12}>
          <label style={{ color: formValues.profile_image ? 'green' : 'red' }}>{formValues.profile_image ? "Firma Logo Mevcut" : "Firma Logo mevcut degil"}</label>
          <div className="custom-input"  >
            <span style={{ backgroundColor: formValues.profile_image ? 'green' : '#00b5e4', fontSize: "13px" }}>
              {formValues.profile_image ? <><i className="fa fa-upload" /> &nbsp;Firma Logo YÜKLENDİ</> : <><i className="fa fa-upload" /> &nbsp;Firma Logo Yükle</>}

            </span>
            <input
              type="file"
              name="profile_image"
              accept=".jpg,.jpeg,.png"
              onChange={(e) => handleDocumentChange(e, "profile_image")}
            />
            {formValues.profile_image && <p style={{ marginLeft: "10px", fontWeight: "bold" }}>{formValues.profile_image.name}</p>}
          </div>
          {formValues.profile_image && <button style={{ marginLeft: "10px", fontWeight: "bold" }} onClick={() => handleRemoveDocument("profile_image")}>Dosyayı Sil <i style={{ color: "red" }} className="fa fa-trash" >{" "}</i></button>}
        </Grid>
      )}

      <Box sx={{ mt: 4, display: "flex", justifyContent: "space-between" }}>
        {/* Back button */}
        <Button
          disabled={activeStep === 0}
          onClick={handleBack}
          variant="outlined"
        >
          GERİ
        </Button>

        {/* Next or Submit button */}
        {activeStep < steps.length - 1 ? (
          <Button onClick={handleNext} variant="contained">
            İLERİ
          </Button>
        ) : (
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "Kaydet"}
          </Button>
        )}
      </Box>
    </Box>} </div> : <NotFoundPage />}</>


  );
};

export default CompanyDetailsForm;
